import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EMOJI_URL,EMOJI_MAP } from './emojiMap';
 

@Component({
  selector: 'app-emoji-picker',
  templateUrl: './emoji-picker.component.html',
  styleUrls: ['./emoji-picker.component.css']
})
export class EmojiPickerComponent implements OnInit {
  @Output() select:EventEmitter<{ key: string, value: string }> = new EventEmitter();  
  constructor() { }

  selectIndex = 0;
  emojiMapList: Array<{ key: string, value: string }>=[];
  ngOnInit(): void {
    this.loadMap();
  }

  loadMap() {
   
    for (var i in EMOJI_MAP) {
      this.emojiMapList.push({ key: i, value: EMOJI_MAP[i] })
    }
  }
  selectItem(index) {
    this.selectIndex = index;
  }

  selectEmoji(item,e){
    this.select.emit(item);
  }
}
